import { UseFormReturn } from "react-hook-form";
import { EsqueceuSuaSenhaForm } from "../../../schemas/esqueceu_sua_senha";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { useEffect } from "react";

import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * EsqueceuSuaSenhaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  infoMessage: string | null;
  errorMessage: string | null;
  hookForm: UseFormReturn<EsqueceuSuaSenhaForm>;
  onClose: () => void;
  onSubmit: (form: EsqueceuSuaSenhaForm) => void;
};

export const EsqueceuSuaSenhaModal = ({
  open,
  saving,
  infoMessage,
  errorMessage,
  hookForm,
  onClose,
  onSubmit,
}: Props) => {

  useEffect(() => {
    if (open) { hookForm.reset(); }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={saving}
      title="Esqueceu sua senha?"
      confirmButtonLabel="Enviar"
      confirmSavingButtonLabel="Enviando..."
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full py-2 flex flex-col gap-4">
        <span>
          Entre com o seu login para receber uma nova senha no seu email cadastrado.
        </span>

        <span>
          Acesse sua conta e alterere sua senha após o login.
        </span>

        <DefaultFormInput
          name='email'
          label='Login'
          reactHookForm={hookForm}
        />

        {infoMessage &&
          <div className="w-full p-2 bg-green-100 text-green-800 border border-green-300 rounded">
            {infoMessage}
          </div>
        }

        {errorMessage &&
          <div className="w-full p-2 bg-red-100 text-red-800 border border-red-300 rounded">
            {errorMessage}
          </div>
        }
      </div>
    </BaseFormControlledModal>
  );
}